import styled from 'styled-components'

const ProductDetailsStyle = styled.div`
	--pdInfoMarginBottom: var(--sp16x);
	--pdInfoMaxWidth: 28.75vw;
	--pdInfoTitleWidth: var(--pdInfoMaxWidth);
	--pdTitleMarginBottom: var(--sp4x);
	--pdImageWidth: 22.73vw;
	--pdImageProportion: 135.22%;
	--pdImageOddTranslateY: -70%;
	--pdImageEvenTranslateY: 0;

	--minSize: 264px;
	--containerDistance: var(--subSectionDistance);

	.pd-container {
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		padding-top: calc(var(--minSize) + var(--containerDistance));

		.pd-info-container {
			display: flex;
			align-items: center;
			flex-direction: column;
			width: 100%;
			max-width: var(--pdInfoMaxWidth);
			margin-bottom: var(--pdInfoMarginBottom);
			text-align: center;

			.pd-title {
				max-width: var(--pdInfoTitleWidth);
				margin-bottom: var(--pdTitleMarginBottom);
			}

			.pd-text {
				white-space: break-spaces;
			}
		}

		.pd-images-container {
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.pd-image {
				width: var(--pdImageWidth);
				border-radius: 30%;
				transform: translate3d(0, 150%, 0);

				.image-cont {
					--proportion: var(--pdImageProportion);

					border-radius: 30%;
					overflow: hidden;
				}

				&:nth-child(2n + 1) .image-cont {
					transform: translate3d(0, var(--pdImageOddTranslateY), 0);
				}

				&:nth-child(2n) .image-cont {
					transform: translate3d(0, var(--pdImageEvenTranslateY), 0);
				}
			}
		}
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		--pdInfoMarginBottom: var(--sp13x);
		--pdInfoMaxWidth: 28.33vw;
		--pdTitleMarginBottom: var(--sp3x);
		--pdImageWidth: 22.81vw;

		--minSize: 196px;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		--pdInfoMarginBottom: var(--sp10x);
		--pdInfoMaxWidth: 27.81vw;
		--pdTitleMarginBottom: var(--sp3x);
		--pdImageWidth: 22.84vw;
		--pdImageOddTranslateY: -95%;

		--minSize: 256px;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		--pdInfoMarginBottom: var(--sp9x);
		--pdInfoMaxWidth: 28.81vw;
		--pdTitleMarginBottom: var(--sp3x);
		--pdImageWidth: 23.33vw;
		--pdImageOddTranslateY: -100%;

		--minSize: 288px;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		--pdInfoMarginBottom: var(--sp8x);
		--pdInfoMaxWidth: 33.75vw;
		--pdTitleMarginBottom: var(--sp3x);
		--pdImageWidth: 23.43vw;
		--pdImageOddTranslateY: -115%;

		--minSize: 308px;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		--pdInfoMarginBottom: var(--sp7x);
		--pdInfoMaxWidth: 34.375vw;
		--pdTitleMarginBottom: var(--sp3x);
		--pdImageWidth: 23.43vw;
		--pdImageOddTranslateY: -115%;

		--minSize: 224px;
	}

	@media only screen and (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		--pdInfoMarginBottom: var(--sp9x);
		--pdInfoMaxWidth: 72.395vw;
		--pdInfoTitleWidth: 80%;
		--pdTitleMarginBottom: var(--sp2-5x);
		--pdImageWidth: 22.65vw;
		--pdImageOddTranslateY: 0;
		--pdImageEvenTranslateY: 50%;

		--minSize: 0;
		--containerDistance: 0;

		.pd-container .pd-images-container {
			align-items: flex-start;

			.pd-image {
				&:nth-child(2n) .image-cont {
					margin-bottom: 50%;
				}
			}
		}
	}

	@media only screen and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		--pdInfoMarginBottom: var(--sp5x);
		--pdInfoMaxWidth: 100%;
		--pdTitleMarginBottom: var(--sp2x);
		--pdImageWidth: 42.02vw;
		--pdImageOddTranslateY: 0;
		--pdImageEvenTranslateY: 50%;

		--minSize: 0;
		--containerDistance: 0;

		.pd-container .pd-images-container {
			flex-wrap: wrap;

			.pd-image {
				&:first-child {
					margin-bottom: var(--sp20x);
				}
			}
		}
	}
`

export default ProductDetailsStyle
